export const SideMenuList = [
  { label: "ChatBot Tool", menu: "chatbot", icon: "fas fa-robot" },
  {
    label: " Fb Templates",
    menu: "templates",
    icon: "fab fa-facebook-square",
    connectiontype: ["nav-fb-tab", "nav-fbinsta-tab"],
  },
  {
    label: " Insta Templates",
    menu: "instatemplates",
    icon: "fab fa-instagram",
    connectiontype: ["nav-inst-tab", "nav-fbinsta-tab"],
  },
  {
    label: "Subscribers",
    menu: "subscribers",
    icon: "fab fa-telegram-plane",
    connectiontype: ["nav-fb-tab", "nav-fbinsta-tab"],
  },
  {
    label: "m.me Links",
    menu: "mmelinks",
    icon: "fa fa-link",
    connectiontype: ["nav-fb-tab", "nav-fbinsta-tab"],
  },
  {
    label: "Opt-in Follow Up",
    menu: "optinfollowup",
    icon: "fas fa-envelope-open-text",
    connectiontype: ["nav-fb-tab", "nav-fbinsta-tab"],
  },
  {
    label: "DM Campaigns",
    menu: "dmcampaigns",
    icon: "fas fa-bullhorn",
  },
  // { label: "Help", menu: "help", icon: "far fa-question-circle" }
];
